import { JWTRole } from "@hackthenorth/north";
import { z } from "zod";

const travelSupportBotSchema = z.object({
  enabled: z.boolean().catch(false),
});

const defaultTravelSupportBot = {
  enabled: false,
};

export const parseTravelSupportBot = (value: unknown) => {
  const result = travelSupportBotSchema.safeParse(value);

  return result.success ? result.data : defaultTravelSupportBot;
};

export const canAccessTravelSupportBot = (
  roles: JWTRole[],
  isOrganizer: boolean,
  botEnabled: boolean
): boolean => isOrganizer || (roles.includes(JWTRole.HACKER) && botEnabled);
